export default {
  header: {
    navTool: "Tool",
    navExamples: "Examples",
    navFairHousing: "Fair Housing",
    navPresentation: "Presentation",
    navBlog: "Blog",
    navPricing: "Pricing",
    tryFree: "Try Free →",
    esToggle: "🇪🇸 ES",
    enToggle: "🇺🇸 EN",
  },
  common: {
    loading: "Loading…",
    error: "Something went wrong. Try again.",
    copied: "Copied!",
    copy: "Copy",
    close: "Close",
    preview: "Preview",
    noCard: "No credit card",
    cancelAnytime: "cancel anytime",
    moneyBack30: "30-day money-back",
    billedUSD: "billed in USD",
    tryFree: "Try Free — No Card Required",
    learnMore: "Learn More →",
    previewAll: "Preview All Pages →",
  },
  hero: {
    est: "EST. 2026 — REAL ESTATE COPY, REWRITTEN",
    headline1: "ChatGPT writes",
    headline2: "$26,262 Fair Housing violations.",
    headline3: "We catch them.",
    subtitle: "One paste → MLS copy, Fair Housing scan, Instagram caption, 5 headlines, buyer email. 10 seconds. Zero compliance risk.",
    subtitle2: "Write your listing in 60 seconds instead of an hour. Try unlimited playground access free. No card required. See the difference yourself.",
    formats: ["MLS Description", "Instagram Caption", "Facebook Post", "5 Headlines", "Buyer Email"],
    formatsTag: "— one click.",
    fhPlaceholder: "Paste your listing copy here",
    fhExample: 'Example: "Perfect for families with kids. Safe, quiet neighborhood near top-rated schools."',
    fhMinChars: "Min. 20 characters",
    fhCheck: "Check for violations",
    fhChecking: "Checking…",
    fhFree: "✦ 100% free",
    fhNoAccount: "● No account",
    fh5Sec: "● 5 seconds",
    fhClean: "No violations found",
    fhCleanMsg: "Your listing passed the Fair Housing check.",
    fhRewrite: "Now rewrite it with AI",
    fhCheckAnother: "Check another",
    fhViolations: "{count} violation(s) — {risk} risk",
    fhIssues: "This listing has Fair Housing issues.",
    fhFix: "Fix with AI — Free Trial",
    fhError: "Something went wrong. Try again.",
    bullets: [
      "✦ Unlimited playground access",
      "● No credit card",
      "● 10s per listing",
      "● Fair Housing scanned",
    ],
  },
  playground: {
    sectionLabel: "/ The Tool",
    toolsLabel: "Browse All Tools",
    heading: "Your boring listing in.",
    heading2: "Five publish-ready assets out.",
    inputLabel: "Input · Raw Listing",
    useSample: "Use sample →",
    placeholder: "Paste your boring MLS draft here. The more detail, the sharper the output.",
    tone: "Tone",
    tones: ["Luxury", "Cozy", "Modern", "Minimalist", "Family", "Investor"],
    outputLang: "Output Language",
    mlsLimit: "MLS Character Limit",
    mlsPresets: [
      "No limit / Default",
      "Bright MLS — 350 words",
      "CRMLS — 400 words",
      "GAMLS — 350 words",
      "Stellar MLS — 300 words",
      "MRED — 350 words",
      "REcolorado — 350 words",
      "Metrolist — 400 words",
      "ACTRIS — 300 words",
      "Custom — 250 words",
      "Custom — 500 words",
    ],
    startFree: "Start Free — Rewrite This Listing",
    rewrite: "Rewrite My Listing",
    rewriting: "Rewriting…",
    freeNote: "3 free rewrites, then from $19/mo · cancel anytime",
    awaiting: "Awaiting input",
    awaitingMsg: "Your rewritten listing will materialize here.",
    awaitingHint: "Paste a draft, pick a tone, hit rewrite. Five publish-ready assets in about ten seconds.",
    generating: "Generating",
    copyCrush: "Copy & Crush It",
    copied: "Copied",
    share: "Share",
    strength: "Strength {score}/10",
    proTip: "Pro tip: Read this straight into your phone camera. No teleprompter needed.",
    tabs: {
      mls: "MLS Description",
      instagram: "Instagram",
      facebook: "Facebook",
      headlines: "Headlines",
      email: "Email",
      reel: "Reel Script",
      stories: "Stories",
      flyer: "Print Flyer",
    },
    proUpsell: "ListWorks PRO",
    proUpsellMsg: "Unlimited rewrites · cinematic videos without watermarks · the AI Advisor in your pocket.",
    getPro: "Get Pro — $29/mo",
    tools: {
      rewrite: "Listing Rewrite",
      staging: "Virtual Staging",
      bio: "Agent Bio",
      photo: "Photo → Listing",
      agentpage: "Agent Page",
      cma: "CMA Report",
      brandvoice: "Brand Voice",
      referral: "Refer & Earn",
      batch: "Bulk CSV",
      expired: "Expired Scripts",
      import: "URL Import",
      seller: "Seller Reports",
      nurture: "Lead Nurture",
      score: "Lead Score",
      transaction: "Transactions",
      openhouse: "Open House",
      fairhousing: "Fair Housing",
      coact: "AI Disclosure",
      voice: "Walk & Talk",
      report: "Sale Report",
      templates: "Social Templates",
      calendar: "Content Calendar",
      marketupdate: "Market Update",
      scheduler: "Schedule Posts",
    },
    meta: {
      address: "Address (optional)",
      price: "Price",
      beds: "Beds",
      baths: "Baths",
      sqft: "Sqft",
      virtualTour: "360° Virtual Tour",
      virtualTourPlaceholder: "https://my.matterport.com/show/?m=...",
    },
    gems: {
      button: "Show Schools · Restaurants · Neighborhood →",
      loading: "Fetching neighborhood data…",
      heading: "Neighborhood Insights",
      add: "Add to my listing →",
      added: "Neighborhood context added to your listing.",    },
    lookup: {
      button: "Auto-fill beds · baths · sqft →",
      loading: "Looking up…",
      success: "Property details auto-filled om public records.",
      notFound: "No public data found — fill in manually.",
    },
  },
  proof: {
    sectionLabel: "/ Receipts",
    headline: "The same listing. Their neighborhood, written in.",
    before: "Before",
    beforeSub: "Generic draft",
    after: "After / ListWorks",
    afterSub: "+ Neighborhood Intelligence — auto-added",
    strength: "Listing Strength",
    strengthScore: "{score}/10",
    stronger: "+{percent}% stronger",
    rewrite: "Rewrite Yours",
    freeCTA: "3 free rewrites · No credit card · See the difference in 10 seconds",
    examplesLabel: "/ Full Examples",
    examplesTitle: "Try these in the playground.",
    examplesCTA: "Try your address →",
    neighborhood: "Neighborhood Intelligence",
    neighborhoodSub: "Try it with any US address.",
    neighborhoodPlaceholder: "Start typing any address...",
    neighborhoodFetch: "Fetch",
    neighborhoodSchools: "Schools",
    neighborhoodDining: "Dining",
    neighborhoodTransit: "Transit",
    neighborhoodEmpty: "will appear here",
    neighborhoodAdd: "Add this to my listing",
    geoloading: "Pulling schools, resturants, and transit data…",
  },
  presentation: {
    sectionLabel: "/ Win More Listings",
    heading: "55-Page",
    heading2: "Listing Presentation",
    subtitle: "Fill-in-the-blank template. CMA worksheets, et proceeds calculator, marketing calendar, compliance pages. Works in your browser — no software needed.",
    buy: "Buy Template — $27",
    cover: "Cover",
    cma: "CMA Worksheet",
    netProceeds: "Net Proceeds",
    mktgCalendar: "Marketing Calendar",
    sections: "36 Fillable Sections",
    guarantee: "Instant download · Editable HTML + PDF · Free updates · 30-day guarantee",
  },
  pricing: {
    sectionLabel: "/ Pricing",
    headline: "Start free. Scale to unlimited.",
    flatRate: "One flat rate",
    noLimits: "No credit limits",
    unlimited: "Unlimited rewrites",
    free: {
      name: "Free",
      price: "$0",
      period: "forever",
      desc: "For agents trying it on their next listing.",
      features: [
        "Unlimited playground access",
        "All 5 output formats",
        "6 tone modes",
        "Fair Housing scanning",
        "See results before saving",
      ],
      cta: "Start Free",
    },
    agent: {
      tag: "For Solo Agents",
      name: "Agent",
      price: "$19",
      period: "/ month",
      desc: "Unlimited rewrites, Fair Housing scans, and your brand voice — everything a solo agent needs.",
      features: [
        "Unlimited listing rewrites",
        "31 social templates in your brand voice",
        "30-day content calendar generator",
        "Live market update generator",
        "Post scheduler with email reminders",
        "Any listing URL import (Zillow, Redfin, MLS…)",
        "Fair Housing scanner + CO Act compliance PDF",
        "Agent Bio Generator (3 formats)",
        "Watermark-free videos",
        "Listing history (forever)",
      ],
      cta: "Get Agent — $19/mo",    },
    pro: {
      tag: "Recommended",
      name: "Pro",
      price: "$39",
      period: "/ month",
      desc: "Everything in Agent plus photo extraction, AI staging credits, video walkthroughs, and listing landing pages.",
      features: [
        "Everything in Agent",
        "Photo-to-feature extraction",
        "AI Video Walkthroughs (watermark-free)",
        "20 AI staging credits / month",
        "Listing landing page + QR lead capture",
        "Multiple brand voice profiles",
        "Reel script generator",
        "Priority video generation",
        "Priority support",
      ],
      cta: "Get Pro — $39/mo",    },
    credits: {
      label: "/ Credits — pay as you go",
      note: "· Each credit = one full rewrite · never expire",
      10: {
        qty: "10 Credits",
        price: "$5",
        desc: "10 AI rewrites — no expiry.",
        badge: "Pay-as-you-go",
      },
      50: {
        qty: "50 Credits",
        price: "$19",
        desc: "50 AI rewrites — best value pay-as-you-go.",
        badge: "Save 24%",
      },
    },
    brokerage: "Need 10+ seats? Talk to brokerage sales →",
  },
  faq: {
    sectionLabel: "/ FAQ",
    headline: "The questions we keep getting.",
    email: "Don't see yours? Email hello@listworks.pro",
    items: [
      {
        q: "Is this just templates?",
        a: "No. ListWorks is a framework wrapped in a tool. You learn WHY each piece works — then the AI applies it to every listing in your voice. Templates copy. Frameworks compound.",
      },
      {
        q: "Do I have to use AI?",
        a: "No. The $20 guide teaches the framework end-to-end so you can write better copy by hand. The AI tool just makes it 27 minutes faster per listing.",
      },
      {
        q: "Will this sound like ChatGPT?",
        a: "Not at all. Generic ChatGPT outputs are average because they're trained on every listing on the internet — including the bad ones. ListWorks is tuned on the Feature → Benefit → Feeling framework that top-1% agents actually use.",
      },
      {
        q: "What if I don't like it?",
        a: "30-day money-back guarantee on the guide. The tool's playground is completely free with unlimited access — try it as many times as you want before deciding to upgrade.",
      },
      {
        q: "Is it MLS-compliant?",
        a: "Yes. Outputs avoid fair-housing landmines, hyperbole, and unverifiable claims by default. Always review before publishing — same as any draft.",
      },
      {
        q: "Can my whole brokerage use it?",
        a: "Yes — the Team plan includes 5 seats, shared listing libraries, and brokerage-specific voice presets. Email hello@listworks.pro for a walkthrough.",
      },
      {
        q: "How is this different from ChatGPT?",
        a: "ChatGPT gives you generic real estate text because it's trained on the whole internet. ListWorks is trained on the Feature → Benefit → Feeling framework — the same system that top-1% agents use to close. One prompt, zero filler.",
      },
      {
        q: "Do the Instagram and Facebook posts actually work?",
        a: "Yes. Over 200 agents use them weekly. Jessica Martinez (LA) closed 2 listings in under a week from posts generated here. Priya Nair (Chicago) said her IG DMs tripled. The captions are built for scroll-stop, not vanity.",
      },
    ],
  },
  footer: {
    tagline: "Real estate copy, rewritten.",
    desc: "Built for agents who'd rather sell homes than stare at MLS forms. Try the tool free. Read the guide once. Use it forever.",
    product: "Product",
    productLinks: ["The Tool", "Examples", "Blog", "Free Tools", "Market Stats", "Compare", "Pricing"],
    compliance: "Compliance",
    complianceLinks: ["Fair Housing Guide", "50 State Guides", "CO AI Disclosure", "Listing Analyzer"],
    earn: "Earn",
    earnLinks: ["Become an Affiliate", "Affiliate Dashboard", "Contact"],
    company: "Company",
    companyLinks: ["Privacy", "Terms"],
    newsletter: "Newsletter",
    newsletterDesc: "One letter / month. The framework, refined. No spam.",
    newsletterPlaceholder: "agent@brokerage.com",
    copyright: "© 2026 ListWorks PRO · Made for agents",
  },
  video: {
    sectionLabel: "/ Video Engine",
    demo: "Live demo",
    headline1: "Ten photos in.",
    headline2: "One cinematic reel",
    headline3: "out.",
    desc: "No editing software. No after-hours. Just upload your listing photos — the AI writes the script, scores the music, and renders a 30-second tour ready for Instagram, Facebook, and your email blast.",
    inputLabel: "INPUT — 10 RAW PHOTOS",
    outputLabel: "RENDERED IN 8 SECONDS",
    overlay: "AI-Generated · 30-Sec Demo",
    makeReel: "Make My Listing Reel",
    seePlans: "See plans →",
    stats: [
      { value: "10", label: "Photos In" },
      { value: "30s", label: "Final Length" },
      { value: "1080p", label: "MP4 Quality" },
      { value: "9:16", label: "Reels Format (Pro)" },
    ],
  },
  contentEngine: {
    sectionLabel: "/ Output Pack",
    headline: "One input. Six publish-ready outputs.",
    tabs: ["Reel Script", "Instagram Caption", "6-Slide Carousel", "7-Day Calendar", "Market Report", "Canva Templates"],
    reel: {
      hook: "Hook (0–3s)",
      middle: "Middle (3–12s)",
      close: "Close (12–15s)",
    },
  },
  qr: {
    sectionLabel: "/ QR Tools",
    headline: "Every listing becomes a lead capture point.",
    signQr: "Sign QR",
    signSub: "Every sign = a lead magnet",
    signStep1: "Rewrite any listing",
    signStep2: "Download the QR code",
    signStep3: "Print on your \"Just Listed\" sign",
    signStep4: "Buyer scans → sees listing on phone → you get the lead",
    signDetail: "Full listing page with photos, description, Fair Housing compliant copy, and a contact form. Your lead gets captured the moment they scan.",
    openHouse: "Open House Check-in",
    openSub: "Auto-captured contacts",
    openStep1: "Create a check-in event in your dashboard",
    openStep2: "Print the QR code",
    openStep3: "Tape it to the front door",
    openStep4: "Visitors scan → drop name + email → no more paper sign-in sheets",
    openDetail: "A mobile-friendly check-in form. Name + email + optional phone. Takes 10 seconds. All leads go straight to your dashboard with timestamp.",
    feedback: "Showing Feedback",
    feedbackSub: "Feedback + lead in one scan",
    feedbackStep1: "Print the QR tent card",
    feedbackStep2: "Leave it on the counter after a showing",
    feedbackStep3: "Buyer scans → rates 1–5 + leaves comment + email",
    feedbackStep4: "You get actionable feedback AND a warm lead",
    feedbackDetail: "A 5-star rating form + comment box + contact capture. Buyers leave feedback anonymously OR drop their info if interested. You get both.",
    seeWhat: "Click to see what buyers see →",
    collapse: "Click to collapse ↑",
    buyerSee: "What buyers see:",
    footer: "No app install required · Works on any phone · Every scan captured to your dashboard",
  },
  contracts: {
    sectionLabel: "/ Contracts",
    headline: "Contracts that explain themselves.",
    desc: "Every field in every contract has a plain-English explanation. No more guessing what 'cooperating broker commission' means.",
    tryFree: "Try It Free →",
    noCard: "No credit card · Free rewrites included",
    list: [
      "Listing Agreement — 14 fields, every one explained",
      "Purchase Agreement — price, contingencies, closing, all broken down",
      "Seller Disclosure — roof, HVac, water damage, legal obligations",
      "Lease Agreement — rent, deposit, pets, subetting, all covered",
      "Buyer Rep Agreement — compensation, term, territory",
    ],
  },
  dashboard: {
    sectionLabel: "/ Dashboard",
    headline: "Everything behind one login.",
    tabs: ["Generator", "Content Packs", "Contracts", "Branding"],
    open: "Open Dashboard →",
    freeNote: "Free account · First 3 rewrites included · No credit card",
  },
  features: {
    sectionLabel: "/ Specifications",
    headline: "Built like a tool.",
    headline2: "Reads like a human.",
    items: [
      { title: "Five-format rewrite", body: "MLS, Instagram, Facebook, headlines, email — all in one pass. Your boring draft becomes five publish-ready assets." },
      { title: "Photo recognition", body: "Upload listing photos. We surface marble, hardwood, vaulted ceilings — and translate them into feelings." },
      { title: "Five tone modes", body: "Luxury. Cozy. Modern. Family. Investor. The same property, dialed for the buyer who's actually shopping." },
      { title: "31 social templates", body: "Just Listed, Just Sold, Open House, Market Update, Testimonial, Tips — all generated in your brand voice, ready to post." },
      { title: "Paste any listing URL", body: "Drop a Zillow, Redfin, or Realtor.com link. We scrape it, extract the details, and pre-fill your rewrite in seconds." },
      { title: "30-day content calendar", body: "One click. A full month of social posts — platform, hook, caption — built around your active listings and brand voice." },
      { title: "Live market updates", body: "Enter any ZIP or city. Get three ready-to-post market update captions — Instagram, Facebook, and email — backed by live data." },
      { title: "Post scheduler", body: "Schedule any caption for later. We email you a reminder with the content ready to copy at exactly the right time." },
      { title: "Fair Housing + CO Act compliance", body: "Scans every listing for HUD-cited violations, auto-generates your Colorado AI Act disclosure, and exports a compliance PDF for your E&O file." },
      { title: "10-second turnaround", body: "Average generation: ten seconds. Beats your average MLS upload form by a country mile." },
      { title: "Saved listing history", body: "Every rewrite saved to your session. Revisit, refine, regenerate without re-typing a single word." },
      { title: "360° Virtual Tour embeds", body: "Plug in any Matterport, Kuula, or CloudPano link. Buyers explore the home in immersive 3D right from your listing." },
    ],
  },
  guide: {
    sectionLabel: "Document No. 001",
    heading: "The Guide. $20.",
    desc: "45 pages. Feature → Benefit → Feeling framework. 15 copy-paste AI prompts. 5-part MLS template. 6 real before/after rewrites with full breakdowns. Read it in one sitting — use it on your next listing the same day.",
    features: [
      "The 5-part listing structure used by top-1% agents",
      "15 plug-and-play prompts for ChatGPT, Claude, Gemini",
      "Buyer psychology triggers that drive showings",
      "Headline formulas that stop scrolls in 1.2 seconds",
    ],
    buy: "Buy the Guide — $20",
    loading: "Loading…",
    preview: "Preview Inside",
    guarantee: "30-day money-back · Lifetime access · Instant download",
    docRef: "LWP-DOC-001",
    rev: "REV. 02 / 2026",
    stats: { pages: "Pages", prompts: "AI Prompts", rewrites: "Rewrites", price: "One-time" },
    modalTitle: "ListWorks Guide",
    modalPreview: "Preview · Pages 1–4",
    modalBuy: "Get the Full Guide — $20",
    moreInside: "More inside. Worth the $20.",
    modalDesc: "Fair Housing chapter · 15 prompts · buyer psychology · pocket cards",
    modalGuarantee: "30-day money-back · instant download",
  },
  testimonials: {
    text: "Built by one founder. Est. 2026. Try it on your own listing — the output is the proof.",
  },
  exitPopup: {
    sectionLabel: "/ Free Download",
    heading1: "Before you go —",
    heading2: "50 headlines that sell.",
    desc: "50 high-converting MLS headlines, organized by property type. Copy, paste, close more deals. Free.",
    moreLabel: "+ 45 more in your inbox",
    placeholder: "your@email.com",
    send: "Send Me 50",
    sending: "Sending…",
    noSpam: "No spam. Unsubscribe anytime.",
    successTitle: "On its way.",
    successDesc: "Check your inbox for 50 headlines that close.",
    successCTA: "Try 3 Free Rewrites While You Wait →",
    headlines: [
      "The one where hardwood floors meet Sunday mornings.",
      "Four walls. Infinite weekends.",
      "The kitchen your dinner parties have been waiting for.",
      "Everything you said you'd wait for. It's here.",
      "This is what 'turn-key' actually means.",
      "Space for the life you're building.",
      "More than a home — a head start.",
      "The backyard your summers have been missing.",
      "Priced to move. Built to stay.",
      "Where the commute ends and the life begins.",
    ],
  },
  fairHousing: {
    banner: "Colorado Agents — AI Disclosure Check",
    bannerCTA: "Create Your Free Record →",
    sectionLabel: "Fair Housing",
    headline: "Fair Housing wasn't designed for AI.",
    desc: "But the $26,000 HUD fine for a single violation applies to whatever wrote the copy. ChatGPT doesn't scan for FHA red flags. ListWorks PRO does — every rewrite, before it reaches your MLS.",
    realExample: "Real example",
    exampleBefore: '"Perfect for families with kids and pets"',
    exampleAfter: "✓ Refreshing natural light across an open floor plan designed for everyday living.",
    footer: "Same home. Same value. No violation.",
  },
  viralNotifications: {
    action: "generated a listing",
    dismiss: "Dismiss",
  },
  presentation: {
    sectionLabel: "/ Win More Listings",
    heading: "55-Page",
    heading2: "Listing Presentation",
    subtitle: "Fill-in-the-blank template. CMA worksheets, net proceeds calculator, marketing calendar, compliance pages. Works in your browser — no software needed.",
    buy: "Buy Template — $27",
    previewAll: "Preview All Pages →",
    viewFull: "View Full Preview & Details →",
    cover: "Cover",
    cma: "CMA Worksheet",
    netProceeds: "Net Proceeds",
    mktgCalendar: "Marketing Calendar",
    sections: "36 Fillable Sections",
    guarantee: "Instant download · Editable HTML + PDF · Free updates · 30-day guarantee",
  },
  video: {
    sectionLabel: "/ Video Engine",
    demo: "Live demo",
    headline1: "Ten photos in.",
    headline2: "One cinematic reel",
    headline3: "out.",
    desc: "No editing software. No after-hours. Just upload your listing photos — the AI writes the script, scores the music, and renders a 30-second tour ready for Instagram, Facebook, and your email blast.",
    inputLabel: "INPUT — 10 RAW PHOTOS",
    outputLabel: "RENDERED IN 8 SECONDS",
    overlay: "AI-Generated · 30-Sec Demo",
    makeReel: "Make My Listing Reel",
    seePlans: "See plans →",
    tapMusic: "Tap · turn music on",
    tapForMusic: "Tap for music",
    soundOn: "Sound on",
    renderedIn: "RENDERED IN 8 SECONDS",
    stats: [
      { value: "10", label: "Photos In" },
      { value: "30s", label: "Final Length" },
      { value: "1080p", label: "MP4 Quality" },
      { value: "9:16", label: "Reels Format (Pro)" },
    ],
  },
  proof: {
    sectionLabel: "/ Receipts",
    headline: "The same listing. Their neighborhood, written in.",
    before: "Before",
    beforeSub: "Generic draft",
    after: "After / ListWorks",
    afterSub: "+ Neighborhood Intelligence — auto-added",
    strength: "Listing Strength",
    strengthScore: "{score}/10",
    stronger: "+{percent}% stronger",
    rewrite: "Rewrite Yours",
    freeCTA: "3 free rewrites · No credit card · See the difference in 10 seconds",
    examplesLabel: "/ Full Examples",
    examplesTitle: "Try these in the playground.",
    examplesCTA: "Try your address →",
    neighborhood: "Neighborhood Intelligence",
    neighborhoodSub: "Try it with any US address.",
    neighborhoodPlaceholder: "Start typing any address...",
    neighborhoodFetch: "Fetch",
    neighborhoodSchools: "Schools",
    neighborhoodDining: "Dining",
    neighborhoodTransit: "Transit",
    neighborhoodEmpty: "will appear here",
    neighborhoodAdd: "Add this to my listing",
    geoloading: "Pulling schools, restaurants, and transit data…",
    addToListing: "Add this to my listing",
    addDesc: "Enter any address — the neighborhood paragraph is added to your draft automatically.",
    neighborhoodParagraph: "Neighborhood paragraph — ready to paste",
    exampleOutput: "Example output",
    liveResult: "Live result",
    fetchError: "Couldn't fetch neighborhood data — check the address and try again.",
  },
};